import FormattedMessage from 'I18n/components/FormattedMessage';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddFormFollowUpEmailView = ({
  auditResult,
  editorApi
}) => {
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "add-form-follow-up-email",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.ADD_FORM_FOLLOW_UP_EMAIL"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.ADD_FORM_FOLLOW_UP_EMAIL"
    }),
    status: auditResult.status,
    action: () => {
      if (auditResult.formModuleId) {
        editorApi.openFormModule({
          moduleId: auditResult.formModuleId
        });
      }
    },
    actionButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.linkText.ADD_FORM_FOLLOW_UP_EMAIL"
    })
  });
};